import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import SendSelectClinicLinkParams from "./OrderResultModel/SendSelectClinicLinkParams"

export default function SendSelectClinicLinkObservable(params: SendSelectClinicLinkParams): Observable<string> {
  const requestBody: string = JSON.stringify(params)

  return ObservableFromFetch<string>("workforceorder/SendSelectClinicLink", requestBody)
}